import { FastField, useFormikContext } from "formik";
import { colors } from "../assets/themes";
import SelectZipCode from "./address-modal/select-zip-code";
import FormControl from "./form-control";
import Icon from "./icon";

const PostalCodeInput = ({ name, placeholder }) => {
  const { setFieldValue, setFieldTouched, validateForm } = useFormikContext();
  const handleSelect = (option) => {
    setFieldValue(name, option?.value?.toString() || "", false);
    setTimeout(() => validateForm(), 0);
  };

  return (
    <FormControl>
      <FastField name={name}>
        {({ field }) => (
          <SelectZipCode
            autoComplete="no-autocomplete"
            LeftComponent={() => <Icon.Large color={colors.mutedLight} name="map-marker" />}
            // value={field.value}
            name={field.name}
            onChange={handleSelect}
            onFocus={() => setFieldTouched(name, true)}
            placeholder={placeholder}
          />
        )}
      </FastField>
    </FormControl>
  );
};

export default PostalCodeInput;
